<template>
  <div class="modal fade show custom-modal" id="NcbAgentsRemark" role="dialog" :class="{'modal-show':showModal}">
    <div class="modal-dialog modal-dialog-centered model-lg">
      <div class="modal-content">
        <div class="modal-body text-center" :class="{'disable-temp-block':agentRemarksLoader}">
          <div class="col-12 text-center mt-5">
            <img
              src="@/assets/images/danger.png"
              alt="danger"
              class="danger-icon"
            />
          </div>
          <p class="mt-2 mb-0">This Proposal would be referred</p>
          <div class="form-group col-12 p-0">
            <float-label label="Agents Remark">
              <textarea
                type="text"
                rows="4"
                cols="30"
                class="form-control"
                v-model="nonStpRemarks.value"
                placeholder="Agents Remark"
              ></textarea>
            </float-label>
          </div>
        </div>
        <div class="col-12 text-right mb-5" :class="{'disable-temp-block':agentRemarksLoader}">
          <span class="loader-small-make-model loader-show-class" v-if="agentRemarksLoader">
                <img src="@/assets/images/loader.gif" alt="done">
          </span>
          <button
            type="button"
            class="btn bgc-btn-secondary mr-3"
            data-dismiss="modal"
            @click ='getCancelEndorsement()'
            id="ncb-agents-cancel"
          >
            Cancel
          </button>
          <button
            type="button"
            class="btn bgc-btn-primary mr-3 w-25"
            data-dismiss="modal"
            @click="nbcDocumentUpload()"
            id="ncb-agents-ok"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FloatLabel from "@/../shared_component/FloatLabel.vue";
import { reactive } from "@vue/composition-api";
export default {
  name: "NcbAgentsRemark",
  props:['agentRemarksLoader','showModal','nonStpRemarks','fromWorkActionUploadDoc'],
  components: {
    FloatLabel,
  },
  setup(props, { root, parent }) {
    let state = reactive({
    documentUploadFlag : false,
    policyNo : false,
    ncbdocument: true,
    });
    function nbcDocumentUpload() {
      if(props.fromWorkActionUploadDoc){
        parent.pendingActionItems(props.nonStpRemarks.value);
      }
      else parent.callIssueEndorsment('agentRemarkModal');
    }
    function getCancelEndorsement(){
      parent.getCancelEndorsement();
    }
    return {
      state,
      nbcDocumentUpload,
      getCancelEndorsement
    };
  },
};
</script>

<style scoped>
.modal-head {
  -ms-flex-negative: 0;
  flex-shrink: 0;
  margin: 28px 5px 12px 5px;
  justify-content: space-between;
}
.btn:hover {
  color: #ffffff;
}
.vfl-has-label {
  position: relative;
  width: 100%;
}
.custom-modal{
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgba(0,0,0,0.4);
    transform:scale(0);
}
.modal-show{
    display:block;
    transform:scaleY(0) scaleX(0);
    animation:unfoldIn 0.25s cubic-bezier(0.165, 0.840, 0.440, 1.000) forwards;
}
.border-bottom{
    font-weight: 900;
    text-transform: none; /* Added for new styling */
    font-size: 23px;
}
@keyframes unfoldIn {
    0% {
        transform:scaleY(.005) scaleX(0);
    }
    50% {
        transform:scaleY(.005) scaleX(1);
    }
    100% {
        transform:scaleY(1) scaleX(1);
    }
}
.loader-small-make-model img{
  max-width: 43px;
  position: absolute;
  top: 8%;
  right: 58%;
}
.loader-show-class{
  display: block;
}
.disable-temp-block{
  opacity: 0.6;
  pointer-events: none;
}
</style>